import { Link, TableCell, TableRow } from '@mui/material';
import React from 'react';

const ProvidersTableRow = ({
  id,
  name = '',
  active = '',
  onClickName = null,
  provider = null,
}) => (
  <TableRow key={`list${id}`} id={id}>
    <TableCell  name="name">
      <Link tabIndex={0} onClick={() => onClickName(provider)}>
        {name}
      </Link>
    </TableCell>
    <TableCell name="active">{active}</TableCell>
  </TableRow>
);

export default ProvidersTableRow;
